import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../../http/clients/api';
import { Observable } from 'rxjs';
import { Deal, DealError } from 'app/models/dto/deal.model';
import { DealLoopRank } from 'ng2-app/models/deals/deal-loop-rank.model';

@Injectable({
  providedIn: 'root'
})
export class DealsService {

  constructor(private http: ApiHttpClient) {}

  get(borrowerId: number): Observable<Deal[]> {
    return this.http.get<Deal[]>('/deal', {
      params: {
        query: JSON.stringify({
          criteria: {
            'deals.borrowerId': { '==': borrowerId }
          },
        }),
      }
    });
  }

  create(newDeal: any): Observable<Deal> {
    return this.http.post<Deal>('/deal/', newDeal);
  }

  getDealById(dealId: number): Observable<Deal> {
    return this.http.get<Deal>(`/deal/${dealId}`);
  }

  update(dealId: number, dealUpdates: any): Observable<Deal> {
    return this.http.put<Deal>('/deal/' + dealId, dealUpdates);
  }

  getDealErrors(borrowerId: number) {
    return this.http.get<DealError[]>('/lender-api/deal-errors/' + borrowerId);
  }

  dismissDealError(errorId: number) {
    return this.http.put<DealError[]>('/lender-api/deal-errors/' + errorId, null);
  }

  runDealLoopRanking(borrowerId: number): Observable<DealLoopRank[]> {
    return this.http.get<DealLoopRank[]>(`/deal/${borrowerId}/run-deal-loop-ranking`);
  }

  unacceptChosenOffer(dealId: number): Observable<void> {
    return this.http.delete<void>(`/deal/${dealId}/contract-request/offer-reset`);
  }
}
